'use client';

import { useLocation } from '@/shared/modern-router';
import { clsx } from 'clsx';

import { Link } from '@/shared/modern-router';

type TTabsProps = {
  tabItems: { url: string; label: string }[];
};

const linkClassName =
  'tw-inline-block tw-font-link2 tw-px-1.6 tw-py-1 tw-text-neutral-light-700 tw-transition-colors tw-ease-in-out tw-duration-200';
export const Tabs: React.FC<TTabsProps> = ({ tabItems }) => {
  const { pathname } = useLocation();

  return (
    <div className="tw-flex">
      {tabItems.map(tabItem => {
        const isSelected = tabItem.url === pathname;
        return (
          <div key={tabItem.label} className="tw-relative">
            <Link
              className={clsx(linkClassName, {
                ' tw-text-primary-light-500 ': isSelected,
              })}
              // @ts-expect-error tech debt from the modernjs migration
              to={tabItem.url}
            >
              {tabItem.label}
            </Link>
            {isSelected ? (
              <div className="tw-absolute tw-bottom-0 tw-right-0 tw-left-0 tw-h-[2px] tw-bg-primary-light-500 tw-rounded-1" />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};
